export default "assets/images/icons/slider-arrow-5cbbcdb3.svg";